import { render, staticRenderFns } from "./music-edit.vue?vue&type=template&id=1f810d50&"
import script from "./music-edit.vue?vue&type=script&lang=js&"
export * from "./music-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports